export default "__VITE_ASSET__6AllvR21__"